import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Composant qui écoute les erreurs d'authentification globales
 * et redirige automatiquement vers la page de logout
 */
const AuthErrorHandler = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Intercepter les erreurs fetch globales
    const originalFetch = window.fetch;
    
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        
        // Vérifier les erreurs d'authentification
        if (response.status === 401 || response.status === 403) {
          console.warn('Session expirée - Redirection vers logout');
          
          // Rediriger vers logout pour nettoyage propre
          navigate('/logout');
        }
        
        return response;
      } catch (error) {
        console.error('Erreur fetch:', error);
        throw error;
      }
    };

    // Écouter l'événement storage pour détecter la déconnexion dans d'autres onglets
    const handleStorageChange = (e) => {
      if (e.key === 'authToken' && !e.newValue) {
        console.log('Déconnexion détectée dans un autre onglet');
        navigate('/logout');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Nettoyer à la fin
    return () => {
      window.fetch = originalFetch;
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate]);

  return children;
};

export default AuthErrorHandler;
